<template>
	<div>
		<transition>
			<b-container fluid>
				<b-form @submit.stop.prevent="onSubmit">
					<!-- ================ melli Code ============ -->
					<b-row align-h="center" class="pt-3 " style="padding-bottomn">
						<b-col md="9" cols="9">
							<b-form-group
								id="melli_code_group"
								:label="$t('register.melliCode')"
								label-for="melli_code"
							>
								<b-form-input
									id="melli_code"
									type="number"
									v-model="$v.form.melli_code.$model"
									:state="validateState('melli_code')"
								>
								</b-form-input>
								<b-form-invalid-feedback
									id="melli_code-live-feedback"
									v-show="!$v.form.melli_code.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="melli_code-live-feedback"
									v-show="
										!$v.form.melli_code.checkMelliCode &
											$v.form.melli_code.required
									"
								>
									{{ $t("validation.MelliCodeCheck") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<!-- ================ mobile number ============ -->
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="mobile_number_group"
								:label="$t('register.mobileNumber')"
								label-for="mobile_number"
								class="marginclass"
							>
								<b-form-input
									id="mobile_number"
									type="number"
									v-model="$v.form.mobile_number.$model"
									aria-describedby="mobile_number-live-feedback"
									:state="validateState('mobile_number')"
								></b-form-input>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="!$v.form.mobile_number.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="
										!$v.form.mobile_number.minLenght |
											!$v.form.mobile_number.maxLenght &&
											$v.form.mobile_number.required
									"
								>
									{{ $t("validation.mobileInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>
					<!-- ================ password ============ -->
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="password_group"
								:label="$t('register.password')"
								label-for="password"
								class="marginclass"
							>
								<b-form-input
									id="password"
									type="password"
									v-model="$v.form.password.$model"
									aria-describedby="password-live-feedback"
									:state="validateState('password')"
								></b-form-input>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="!$v.form.password.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="
										!$v.form.password.minLenght & $v.form.password.required
									"
								>
									{{ $t("validation.passwordInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- ================ repassword ============ -->
					<b-row align-h="center">
						<b-col md="9" cols="9">
							<b-form-group
								id="password_group"
								:label="$t('register.repassword')"
								label-for="password"
								class="marginclass"
							>
								<b-form-input
									id="repassword"
									type="password"
									v-model="$v.repassword.$model"
									aria-describedby="repassword-live-feedback"
									:state="validate()"
								></b-form-input>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="!$v.repassword.required"
								>
									{{ $t("validation.required") }}
								</b-form-invalid-feedback>
								<b-form-invalid-feedback
									id="mobile_number-live-feedback"
									v-show="!$v.repassword.same & $v.repassword.required"
								>
									{{ $t("validation.repasswordInvalid") }}
								</b-form-invalid-feedback>
							</b-form-group>
						</b-col>
					</b-row>

					<!-- ================ butten ============ -->
					<b-row align-h="center" class="justify-content-center">
						<b-col cols="9">
							<div>
								<b-button
									type="submit"
									size="md"
									class="btn btn-hover--3d btn-left btn-bg--primary"
									>{{ $t("register.signUp") }}
								</b-button>
							</div>
						</b-col>
					</b-row>
				</b-form>

				<!-- ================ have an account ============ -->
				<b-row align-h="center" class="mb-1 pb-1">
					<b-col md="8" cols="9">
						<hr />
						<small class="text-color--400 ">
							{{ $t("login.haveAccount") }}
							<b-link to="/newlogin"> {{ $t("login.login") }}</b-link>
						</small>
					</b-col></b-row
				>
			</b-container>
		</transition>
	</div>
</template>

<script>
import Vue from "vue";
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";

import { required, minLength, maxLength } from "vuelidate/lib/validators";

Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
export default {
	mounted() {
		if (localStorage.getItem("supplierCustomerId")) {
			this.$noty.warn(
				this.$t("شمار به عنوان تامین کننده در حال ثبت نام یک متقاضی هستید"),
			);
		}
	},
	data() {
		return {
			form: {
				melli_code: "",
				mobile_number: "",
				password: "",
			},
			repassword: "",
		};
	},
	validations: {
		form: {
			melli_code: {
				required,
				checkMelliCode(code) {
					if (
						!/^\d{10}$/.test(code) ||
						code == "0000000000" ||
						code == "1111111111" ||
						code == "2222222222" ||
						code == "3333333333" ||
						code == "4444444444" ||
						code == "5555555555" ||
						code == "6666666666" ||
						code == "7777777777" ||
						code == "8888888888" ||
						code == "9999999999"
					)
						return false;
					var check = parseInt(code[9]);
					var sum = 0;
					var i;
					for (i = 0; i < 9; ++i) {
						sum += parseInt(code[i]) * (10 - i);
					}
					sum %= 11;
					return (sum < 2 && check == sum) || (sum >= 2 && check + sum == 11);
				},
			},
			mobile_number: {
				required,
				minLength: minLength(11),
				maxLength: maxLength(11),
			},
			password: {
				required,
				minLength: minLength(6),
			},
		},
		repassword: {
			required,
			same(pass) {
				if (pass == this.form.password) {
					return true;
				}
				return false;
			},
		},
	},
	methods: {
		onSubmit() {
			this.$v.$touch();
			if (this.$v.$invalid) {
				this.submitStatus = "ERROR";
				this.$noty.info(this.$t("alert.alertInvalidField"));
			} else {
				console.log(localStorage.getItem("customer"));
				let load = this.$loading.show();
				this.$store
					.dispatch("getOtp", this.form)
					.then((response) => {
						console.log(response);
						this.$router.push({ name: "otp" });
						load.hide();
					})
					.catch((err) => {
						console.log(err);
						this.errors = err.body;
						this.$noty.error(err.body.error);
						load.hide();
					});
			}
		},

		validateState(name) {
			const { $dirty, $error } = this.$v.form[name];
			return $dirty ? !$error : null;
		},
		validate() {
			const { $dirty, $error } = this.$v.repassword;
			return $dirty ? !$error : null;
		},
	},
};
</script>

<style scoped>
.btn-left {
	display: block;
	margin: auto;
}
.is-valid,
.is-invalid {
	background-position: center right 2px;
}
b-form-group {
	margin-bottom: -30px;
}
.marginclass {
	margin-top: -1.6rem;
}

</style>
<style scoped scr="bootstrap/dist/css/bootstrap.css"></style>
<style scoped scr="bootstrap-vue/dist/bootstrap-vue.css"></style>
